<div class="no-scroll" [ngClass]="{'scroll': scroll}"></div>

<section *ngIf="!initialVideo" class="section section-parallax get-started">
		<div class="bg-wrap">
			<div class="bg">
				<div class="container gennius">
					<div class="gennius__center" (click)="playInitialVideo()">
						<div class="started">
							<div class="play"></div>
							<img class="icon-imagine" src="./assets/img/gennius/icon-get.svg">
						</div>
						<span>Get Started</span>
					</div>
				</div>
			</div>
		</div>
</section>
<section class="say-hello" #scrollContainer>
	<div class="filter"></div>
	<video [hidden]="initialVideo" autoplay="" loop="loop" playsinline="" oncanplay="this.play()" onloadedmetadata="this.muted = true" poster="./assets/img/gennius/poster-imagine.webp">
			<source
					src="https://player.vimeo.com/progressive_redirect/playback/881285062/rendition/720p/file.mp4?loc=external&signature=98ed65e0f0616a41d91011594925d0a58d370ba972fb753e8682435c939d3afd" type="video/mp4">
	</video>
	<video class="initial-video" [hidden]="!initialVideo" preload="metadata" playsinline="" poster="./assets/img/gennius/soledad.webp" onloadedmetadata="this.muted = true">
		<source src="https://player.vimeo.com/progressive_redirect/playback/882162872/rendition/720p/file.mp4?loc=external&signature=719c9b37b7d3d51772b98deef861a0c5763f8898abdf8cb25ca81ac13f78ade4" type="video/mp4">
	</video>
	<section class="section scroll-auto section-parallax parallax-1 ">
		<div id="item-c">
			<div class="bg-wrap">
				<div class="bg">

					<div class="container gennius">
						<div class="gennius__center target1">
								<img class="logo-imagine" src="./assets/img/gennius/logo-imagine.svg">
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section scroll-auto section-parallax ">
		<div id="item-d">
			<div class="bg-wrap">
				<div class="bg">

					<div class="container gennius">
						<div class="gennius__center target2">
								<img class="logo-imagine" src="./assets/img/gennius/logo-imagine.svg">
								<img class="logo-imagine logo-shit logo-imagine--blue logo-imagine--big" data-class-in="animate" src="./assets/img/gennius/logo-imagine-blue.svg">
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section scroll-auto section-parallax ">
		<div id="item-e">
			<div class="bg-wrap">
				<div class="bg">

					<div class="container gennius">
							<div class="gennius__center target3">
									<img class="logo-imagine logo-imagine--transition" data-class-in="animate" src="./assets/img/gennius/logo-imagine.svg">
									<img class="logo-imagine logo-imagine--blue" src="./assets/img/gennius/logo-imagine-blue.svg">
							</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class="section scroll-auto section-parallax parallax-4 ">
		<div id="item-f">
			<div class="bg-wrap">
				<div class="bg">

					<div class="container gennius">
											<div class="gennius__center target4">
													<img class="logo-imagine logo-imagine--blue" src="./assets/img/gennius/logo-imagine-blue.svg">
													<h2 class="imagine-title">
															<span data-class-in="animate">one currency</span><br>
															<span data-class-in="animate" class="subtext">rewards <small>|</small> fiat <small>|</small> crypto</span>

													</h2>
											</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  <section class="section scroll-auto section-parallax ">
		<div id="item-g">
			<div class="bg-wrap">
				<div class="bg">

					<div class="container gennius">
											<div class="gennius__center target5" >
													<img class="logo-imagine logo-imagine--blue" src="./assets/img/gennius/logo-imagine-blue-w.svg">
													<h2 class="imagine-title">

															<span data-class-in="animate">one e-wallet</span><br>
															<span data-class-in="animate" class="subtext">
															in store <small>|</small> web2 <small>|</small> web3 <small>|</small><br>
															instant money movement
															</span>
													</h2>
											</div>
					</div>
				</div>
			</div>
		</div>
	</section>
  <section class="section scroll-auto section-parallax ">
	<div id="item-h">
		<div class="bg-wrap">
			<div class="bg">

				<div class="container gennius">
						<div class="gennius__center target6">
								<img class="logo-imagine logo-imagine--blue" src="./assets/img/gennius/logo-imagine-blue-w.svg">
								<h2 class="imagine-title">
										<span data-class-in="animate">one team</span><br>
										<span data-class-in="animate" class="subtext logos-team">
												<img class="img-logos-team" src="./assets/img/gennius/logos-team.svg">
										</span>
								</h2>
						</div>
				</div>
			</div>
		</div>
	</div>
	</section>
  <section class="section scroll-auto section-parallax ">
	<div id="item-i">
		<div class="bg-wrap">
			<div class="bg">

				<div class="container gennius">
					<div class="gennius__center target7">
							<img class="logo-imagine logo-imagine--blue" src="./assets/img/gennius/logo-imagine-blue-w.svg">
							<h2 class="imagine-title imagine-title--left">
									<span data-class-in="animate" class="t-desktop">Everything&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;as One</span>
									<span data-class-in="animate" class="t-responsive">Everything &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;as One</span>
							</h2>
					</div>
				</div>
			</div>
		</div>
	</div>
	</section>
  <section class="section scroll-auto section-parallax ">
	<div id="item-j">
		<div class="bg-wrap">
			<div class="bg">

				<div class="container gennius">
				<div class="gennius__center target8">
						<img data-class-in="animate" class="logo-imagine logo-imagine--blue logo-imagine--big logo-imagine--fadeOut" src="./assets/img/gennius/logo-imagine-blue-w.svg">
						<img data-class-in="animate" class="logo-imagine logo-imagine--fadeIn" src="./assets/img/gennius/logo-imagine.svg">
				</div>
				</div>
			</div>
		</div>
	</div>
	</section>
  <section class="section scroll-auto section-parallax ">
	<div id="item-k">
		<div class="bg-wrap">
			<div class="bg">

				<div class="container gennius">
					<div class="gennius__center target9">
						<img data-class-in="animate" class="one-world logo-imagine--fadeIn" src="./assets/img/gennius/image-one-world.webp">
						<img data-class-in="animate" class="logo-imagine logo-imagine--transition" src="./assets/img/gennius/logo-imagine.svg">
					</div>
				</div>
			</div>
		</div>
	</div>
	</section>
	<section class="section scroll-auto section-parallax parallax-5 " [ngClass]="{'fixed': fixed} || {'scroll': fixed}">
		<div id="item-l">
			<div class="container-fixed viewVisible" data-class-in="fixed" data-class-out="fixed">
				<img class="one-world logo-imagine--fadeOut one-world-fixed" src="./assets/img/gennius/image-one-world.webp">
					<!-- <span *ngIf="!itsMobile" class="icon-play" [ngClass]="{'hide': play}" (click)="playVideo()"></span> -->
				<video class="video-one" preload="metadata" playsinline="" (ended)="vidEnded()">
					<source src="https://player.vimeo.com/progressive_redirect/playback/882162872/rendition/720p/file.mp4?loc=external&signature=719c9b37b7d3d51772b98deef861a0c5763f8898abdf8cb25ca81ac13f78ade4" type="video/mp4">
				</video>
			</div>

		</div>

	</section>
	<section class="section section-parallax parallax-5 section-items ">
		<div class="container">
			<div class="bl-items">
				<div class="button" (click)="topPage()">
					<div class="item-icon"></div>
					<span>Start again</span>
				</div>
				<div class="button" (click)="openModal('1')">
					<div class="item-icon"></div>
					<span>About Soledad</span>
				</div>
			</div>
		</div>
	</section>
</section>

<div class="modal-one close-web" [ngClass]="{'open': modal1}">
	<span class="icon-close" (click)="closeModal('1')"></span>

	<div class="modal__text">

		<h2>SOLEDAD SURPRISED AND THRILLED LIONEL MESSI</h2>
		<span class="subtittle">THE ARGENTINE SINGER-SONGWRITER PERFORMED HER ICONIC SONG “BRINDIS” TO THE ARGENTINE NATIONAL TEAM AT THE GREAT EVENT ORGANIZED BY CONMEBOL FOR THE WORLD CHAMPIONS.</span>

		<img class="one-world" src="./assets/img/gennius/image-about.webp">

		<button class="button-watch"><span class="icon-watch"></span><a href="https://www.instagram.com/p/CqT2gpPPWCq/" target="_blank"><p>Watch video</p></a></button>

		<div class="bl-center">
			<span class="special">By Sony Music Entertainment Argentina.</span>

			<p><strong>On Monday, March 27th, in Luque, Paraguay, Soledad was the guest artist invited by Conmebol to perform “Brindis” to the
				National Team, a song that accompanied the Scaloneta before and during the World Cup and became an anthem, as its lyrics
				talk about effort, sacrifice and never giving up.</strong></p>

			<p>To the surprise and joy of the entire staff, Soledad gave them an emotional version of the emblematic song.</p>

			<p>“Brindis”, which is one of Soledad's best-known songs worldwide, was composed for her by Afo Verde celebrating her then first ten years of career, and began to become famous when she performed a particular version of it at the Teatro Gran Rex in Buenos Aires for the unforgettable icon Diego Maradona, who always highlighted the emotional chills that the lyrics generated in him.</p>

			<p>That same emotion was reflected yesterday in the eyes of Lionel Messi, the most important Argentine football player in the world.
				Because Messi had already chosen the song "Brindis" to musicalize an emotional video posted a month after winning the World Championship, which in a few days surpassed one hundred million views in social media.</p>

			<p>Soledad, who embraced Messi, also said to him when singing the last verse <strong>"Argentina thanks you"</strong> and then she praised the rest of the team because <strong>“they have shown unity; they have given us an example to follow”</strong>. Finally, she closed her unforgettable performance saying, <strong>"for me it has been an honor and I will keep this with me for the rest of my life"</strong>.</p>

			<p>In his speech, Messi, expressly thanked Conmebol’s President Alejandro Domínguez for inviting Soledad to perform “Brindis” during the event and gave an explanation about the importance of the song for him and the rest of his teammates. <strong>"I want to thank you, all at Conmebol, for this tribute to all of us. The gift that Sole gave us just now was very touching. The song is very
				meaningful for us because we listened to it in the locker room and the fact that Sole is here performing it to us reminded me -
				as she said- of that moment when she sang it to Diego (Maradona). The fact that she sang it to me, that she sang it to
				us, was a very nice moment, so thank you very much"</strong>.</p>

			<p>On the other hand, the author and producer of the song Afo Verde, current CHAIRMAN & CEO SONY MUSIC LATIN IBERIA,
				commented: <strong>"For me it is always an honor to work with Sole. When she told me what she was going through in her life, it when she told me what she was going through in her life, it occurred to me to compose this song as a tribute to what had been those 10 years of effort and sacrifice. To stop for a little while and toast for everything that had happened to her, and all she had already achieved. Sole is someone who is always close to my heart, and as an Argentine, a fan of football, Leo and our national team, I am honored and shocked that it has been an important and representative song for the group at this special moment”</strong>.</p>

			<span><strong>ABOUT SOLEDAD</strong></span>

			<p>Argentine singer-songwriter and performer, she is also a well-known TV hostess in musical tv shows. She has multiple nominations to the Latin GRAMMY®, and GRAMMY AWARDS ®. She is the only Argentinean artist to receive 2 DIAMOND Awards, as well as multiple Gold and Platinum records. She starred in two movies, one of them with more than 1.5 million viewers, and was a judge in the three editions of the reality show LA VOZ ARGENTINA ("The Voice"), and ELEGIDOS ("Rising Star").</p>

			<p>She has performed more than 2500 shows in Argentina and in different countries throughout America and Europe. She has recorded 18 albums of her own, with millions of records sold. She has recorded duets and participated in songs with Joan Manuel Serrat, Santana, Carlos Vives, Franco de Vita, India Martinez, Kany Garcia, Niña Pastori, Lila Downs, Rocio Durcal, Alejandro Sanz and Juanes, among others. Her albums, collaborations and presentations have been awarded with multiple Gardel
				Awards, Antorcha and Gaviota de Plata de Viña del Mar awards, as well as the Latin GRAMMY®.</p>

				<p>She was invited to sing for Pope Francis and more than 3 million spectators, as part of the WYD in Rio de Janeiro. In February 2018, she participated in the first Latin GRAMMY® Acoustic Sessions in Argentina. Together with Jaime Camil, she was chosen in 2018 by The Latin Recording Academy, to host the Latin GRAMMY® "Person Of The Year" event in Las Vegas, being the first time such ceremony was held with presenters.</p>

				<p>She hosted in TV Publica Argentina the musical program "Ecos de mi Tierra", twice a winner of the MARTIN FIERRO award and once of the TATO award (Air TV). Since 2012, Soledad is one of the main coaches in the Argentine edition of LA VOZ, contest that her teams have already won 3 times.</p>


			<div class="redes-one">
				<div class="item">
					<img src="./assets/img/gennius/facebook-icon.svg">
					<a href="https://www.facebook.com/solepastorutti" target="_blank"><span>Facebook</span></a>
				</div>
				<div class="item">
					<img src="./assets/img/gennius/instagram-icon.svg">
					<a href="https://www.instagram.com/sole_pastorutti/" target="_blank"><span>Instagram</span></a>
				</div>
				<div class="item">
					<img src="./assets/img/gennius/youtube-icon.svg">
					<a href="https://www.youtube.com/@sole_pastorutti" target="_blank"><span>Youtube</span></a>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="bg-mob">
    <div class="content">
        <img class="logo-imagine" src="./assets/img/gennius/logo-imagine.svg">
        <img class="icon-landscape" src="./assets/img/gennius/landscape.svg" alt="">
        <p>To enhance your experience, <br> tilt your device.</p>
    </div>
</div>